const Questions = () => {
  return (
    <a style={{ cursor: 'pointer' }} href="https://help.swagup.com" target="_blank" rel="noopener noreferrer">
      <img src={`${process.env.PUBLIC_URL}/imgs/public/question.svg`} alt="question" />
    </a>
  );
};

export default Questions;
